import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.hero = this.element.querySelector("[data-landing-hero]")
    this.logo = this.element.querySelector("[data-landing-logo]")
    this.header = document.querySelector("header")
    this.raf = null

    this.update = this.update.bind(this)

    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(() => this.scheduleUpdate())
      if (this.hero) this.observer.observe(this.hero)
      if (this.logo) this.observer.observe(this.logo)
      if (this.header) this.observer.observe(this.header)
    }

    window.addEventListener("resize", this.update, { passive: true })
    window.addEventListener("orientationchange", this.update, { passive: true })

    requestAnimationFrame(this.update)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()

    window.removeEventListener("resize", this.update)
    window.removeEventListener("orientationchange", this.update)

    if (this.raf) {
      window.cancelAnimationFrame(this.raf)
    }
  }

  scheduleUpdate() {
    if (this.raf) return

    this.raf = window.requestAnimationFrame(() => {
      this.raf = null
      this.update()
    })
  }

  update() {
    if (!this.hero || !this.logo) return

    const viewportHeight = window.visualViewport?.height || window.innerHeight
    const headerHeight = this.header?.offsetHeight || 0
    const logoHeight = this.logo.offsetHeight || 0
    const heroMinHeight = Math.max(0, Math.floor(viewportHeight - headerHeight - logoHeight))

    this.hero.style.minHeight = `${heroMinHeight}px`
  }
}
